import { render } from "./PromptManager.vue?vue&type=template&id=90255f7e"
import script from "./PromptManager.vue?vue&type=script&lang=js"
export * from "./PromptManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__